module.exports = "<div class=\"pcheckbox\">\n    <div class=\"pcheckmark\" *ngIf=\"checked\"></div>\n</div>\n<div class=\"plabel\">{{label}}</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/polymer/paper-checkbox/paper-checkbox.component.html
// module id = ./src/app/components/polymer/paper-checkbox/paper-checkbox.component.html
// module chunks = main